import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule, DatePipe } from '@angular/common';
import { Component, DebugElement, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { ActivatedRoute, Router } from '@angular/router';
import { wizardTermsAndConditions } from '../../../data/wizard-terms.data';
import { wizardData, wizardOptions } from '../../../data/wizard.data';
import { GoogleMapsAutocompleteComponent } from '../../components/google-maps-autocomplete/google-maps-autocomplete.component';
import { WizardFormBtnComponent } from '../../components/wizard-form-btn/wizard-form-btn.component';
import { WizardFormInputComponent } from '../../components/wizard-form-input/wizard-form-input.component';
import { WizardStartFormComponent } from '../../components/wizard-start-form/wizard-start-form.component';
import { Address } from '../../interfaces/home';
import { WizardData } from '../../interfaces/wizard';
import { AddressService } from '../../services/address.service';
import { ClientCookiesService } from '../../services/client-cookies.service';
import { DateService } from '../../services/date.service';
import { FormSubmissionService } from '../../services/form-submission.service';
import { SessionService } from '../../services/session.service';
import { WizardFormSelectComponent } from '../../components/wizard-form-select/wizard-form-select.component';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FeatureFlagsService } from '../../services/feature-flags.service';
import { VariationsResponse } from '../../interfaces/VariationResponse';

@Component({
  selector: 'app-wizard',
  standalone: true,

  imports: [
    CommonModule,
    FormsModule,
    WizardFormBtnComponent,
    WizardFormInputComponent,
    WizardFormSelectComponent,
  ],
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.css'],
  animations: [
    trigger('fadeDown', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-15px)' }),
        animate(
          '600ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),

    trigger('fadeUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(15px)' }),
        animate(
          '600ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),

    trigger('opacityAnimation', [
      transition(':enter', [
        style({ opacity: 0.3 }),
        animate('600ms ease-in-out', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class WizardComponent implements OnInit {
  @Input() checkFormNumber!: (number: number) => void;
  @Input() googleApiKey: string | undefined;
  @Input() questionStart: boolean = false;
  @Output() questionStartChange = new EventEmitter<boolean>();

  constructor(
    private sanitizer: DomSanitizer,
    private addressService: AddressService,
    private dateService: DateService,
    private formSubmissionService: FormSubmissionService,
    private sessionService: SessionService,
    private router: Router,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private clientCookiesService: ClientCookiesService,
    private featureFlagService: FeatureFlagsService,

  ) {

  }

  wizardDataInfo: WizardData[] = wizardData;
  showedWizardPages: Map<string, WizardData> = new Map();
  termsAndConditions = wizardTermsAndConditions;

  isAddressManual: boolean = false;
  activeFormName: string = wizardData[0].formPageName;
  activeFormIndex: number = 0;

  formattedIncome: string = '';

  @ViewChild('dateOfBirthInput') dateOfBirthElement: ElementRef | undefined;
  dateOfBirth: string = '';
  maxDate: string = '';
  datePlaceholder: string = 'MM/DD/YYYY';

  dateInvalid: boolean = false;

  sliderValue: number = 15;
  loanSize: string = '$15,000';

  checkboxamOne: boolean = true;
  checkboxamMl: boolean = true;

  ngCheckboxamOne: boolean = true;
  ngCheckboxamMl: boolean = true;

  progressBar: number[] = [];

  address: Address = {
    streetNumber: '',
    streetAddress: '',
    streetAddressSecond: '',
    city: '',
    state: '',
    zipcode: '',
  };

  fullAddress: string = '';

  sessionId: string | null = null;

  insuranceProviderPageIndex = 0;
  googleUser: boolean = false;
  isKissterraCampaign: boolean = false;

  ngOnInit() {
    this.route.data.subscribe({
      next: (data) => {
        const session = data['session'];
        if (session?.['session-uuid']) {
          this.sessionId = session['session-uuid'];  // Store session ID
          console.log('Session retrieved:', this.sessionId);
        } else {
          console.warn('No session found, redirecting...');
          this.router.navigate(['/error']);
        }
        this.maxDate = this.dateService.getMaxDate();

        this.googleUser = this.isGoogleUser();
        this.isKissterraCampaign = this.iskissterraCampaign();

        const variation = this.featureFlagService.findVariationByFeatureFlagName('long_short_funnel_ff');
        const isShortFunnel = variation?.variationName === 'short_funnel_version';
        if ((isShortFunnel && !this.googleUser) || this.isKissterraCampaign) {
          this.showedWizardPages = this.findThePagesToShow('onlyZipPages');
        } else {
          this.showedWizardPages = this.findThePagesToShow('defaultPages');
        }


        this.autoDetectZipcode();
      },
      error: (err) => {
        console.error('Error resolving session:', err);
      }
    });
  }

  autoDetectZipcode() {
    if (typeof window !== 'undefined' && localStorage) {
      let geoIp: any = localStorage.getItem('geoIP');
      if (geoIp) {
        try {
          const parsedGeoIp = JSON.parse(geoIp);
          if (parsedGeoIp && this.showedWizardPages.get('ZipCodePage')) {
            let page = this.showedWizardPages.get('ZipCodePage');
            const zipCode = parsedGeoIp.zipcode;
            if (page && page.writtenAnswers) {
              page.writtenAnswers['zipcode'] = zipCode;
            }
          }
        } catch (error) {
          console.warn('Error parsing geoIP from localStorage:', error);
        }
      }
    }
  }

  private iskissterraCampaign(): boolean {

    try {
      let urlParms = localStorage.getItem('urlParams');
      if (urlParms) {
        let urlParams = JSON.parse(urlParms);
        if (urlParams && urlParams['Campaign ID']) {
          if (urlParams['Campaign ID'] === '120215998472560352') {
            return true;
          }
        }
      }
    } catch (e) {
      console.log('Error on iskissterraCampaign ' + JSON.stringify(e));
    }
    return false;

  }

  private isGoogleUser(): boolean {
    try {
      let urlParms = localStorage.getItem('urlParams');
      if (urlParms) {
        let urlParams = JSON.parse(urlParms);
        if (urlParams && urlParams['utm_source']) {
          if (urlParams['utm_source'] === 'googleads') {
            return true;
          }
        }
      }
    } catch (e) {
      console.log('Error on isGoogleUser ' + JSON.stringify(e));
    }
    return false;
  }

  private waitForRender(callback: () => void) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        callback();
      });
    });
  }

  onCheckboxChange(event: Event, checkboxName: string): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkboxName === 'Ml') {
      this.checkboxamMl = checkbox.checked;
    }
    if (checkboxName === 'One') {
      this.checkboxamOne = checkbox.checked;
    }
  }


  findThePagesToShow(option: string): Map<string, WizardData> {
    let choosenPages = wizardOptions[option as keyof typeof wizardOptions];

    const findedPages = this.wizardDataInfo.filter((page) => {
      return wizardOptions[option as keyof typeof wizardOptions].includes(
        page.formPageName
      );
    });

    this.progressBar = Array.from(
      { length: findedPages.length - 1 },
      (_, i) => i
    );

    findedPages.forEach(page => {
      //find page index from choosenPages
      let choosenPageIndex = choosenPages.findIndex(
        (choosenPage) => choosenPage === page.formPageName
      );
      page.formNumber = choosenPageIndex;
    });

    //converfindedPages to map
    let findedPagesMap = new Map();
    findedPages.forEach(page => {
      if (page.formPageName === 'InsuredPage') {
        this.insuranceProviderPageIndex = page.formNumber + 1;
      }
      findedPagesMap.set(page.formPageName, page);
      //init first page index
      if (page.formNumber == 0) {
        this.activeFormName = page.formPageName;
      }
    });

    return findedPagesMap;
  }

  onAddressChange(address: Address): boolean {
    this.address = address;
    this.fullAddress = this.addressService.getFullAddress(address);

    const { streetNumber, ...addressWithoutStreetNumber } = address;
    return this.addressService.isAddressComplete(addressWithoutStreetNumber);
  }


  onDateChange(value: any, formPageNumber: string) {
    // Remove non-digit characters
    const cleaned = value.replace(/\D/g, '');

    // Initialize the placeholder template
    const template = this.datePlaceholder;

    // Dynamically format the date based on the length of the input
    let formatted = '';
    if (cleaned.length > 0) {
      formatted += cleaned.slice(0, 2); // MM
    }
    if (cleaned.length > 2) {
      formatted += '/' + cleaned.slice(2, 4); // DD
    }
    if (cleaned.length > 4) {
      formatted += '/' + cleaned.slice(4, 8); // YYYY
    }

    // Fill in remaining placeholder characters
    this.dateOfBirth = formatted + template.slice(formatted.length);


    // Update the input field
    if (this.dateOfBirthElement) {
      this.dateOfBirthElement.nativeElement.value = this.dateOfBirth;
    }

    (
      this.showedWizardPages.get(formPageNumber) as any
    ).writtenAnswers.dateOfBirth = this.dateOfBirth;
  }

  returnCurser(event: any) {
    let value = event.target.value;
    var cleaned = value.replaceAll(/\D/g, '');
    let lastSize = 0;
    value = cleaned.replaceAll('/', '');
    if (event.key !== 'Backspace') {
      if (value.length >= 1 && value.length <= 3) {
        lastSize = value.length + 1;
      } else if (value.length >= 4) {
        lastSize = value.length + 2;
      }
    } else if (event.key === 'Backspace') {

      if (value.length >= 5 && value.length <= 8) {
        lastSize = value.length + 2;
      } else if (value.length === 3 || value.length === 4) {
        lastSize = value.length + 1;
      } else if (value.length <= 2) {
        lastSize = value.length;
      }
    }
    if (this.dateOfBirthElement) {
      this.dateOfBirthElement.nativeElement.setSelectionRange(lastSize, lastSize);
      this.dateOfBirthElement.nativeElement.focus();
    }
  }

  onLoanAmountValuesUpdate(updatedValues: {
    sliderValue: number;
    loanSize: string;
  }): void {
    this.sliderValue = updatedValues.sliderValue;
    this.loanSize = updatedValues.loanSize;
  }

  isDateValid(question: any): boolean {
    let res = false;
    if (question && question.writtenAnswers['dateOfBirth'].length === 10 && !/[MDY]/.test(question.writtenAnswers['dateOfBirth'])) {

      res = (
        question.writtenAnswers?.['dateOfBirth'] &&
        this.dateService.isDateBeforeToday(
          new Date(question.writtenAnswers['dateOfBirth'])
        )
      );
    }

    return res;
  }

  isEmailValid(): boolean {
    const email = (this.showedWizardPages.get(this.activeFormName) as any)
      .writtenAnswers['email'];
    return /^[^\s@]+@(hotmail\.com|outlook\.com|comcast\.net|gmail\.com|aol\.com|loansgenerator\.com|icloud\.com|yahoo\.com)$/.test(
      email
    );
  }

  handleIncomeValueChange(event: any): void {
    const value = event.target.value;
    const filteredValue = value
      .split('')
      .filter((elm: string) => /^\d+$/.test(elm))
      .join('');
    const formattedValue = /^\d+$/.test(filteredValue)
      ? '$'.concat(
        filteredValue.replace(/^0+/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      )
      : filteredValue;
    (this.showedWizardPages.get(this.activeFormName) as any).writtenAnswers[
      event.target.id
    ] = formattedValue;
    event.target.value = formattedValue;
  }

  handleFormatPhoneNumber(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 3) value = `${value.slice(0, 3)}-${value.slice(3)}`;
    if (value.length > 7) value = `${value.slice(0, 7)}-${value.slice(7)}`;
    value = value.slice(0, 12);

    (this.showedWizardPages.get(this.activeFormName) as any).writtenAnswers[
      event.target.id
    ] = value;
    event.target.value = value;
  }

  handleFormatZipCode(event: any): void {
    //max 5 digits
    let value = event.target.value.replace(/\D/g, '').slice(0, 5);
    (this.showedWizardPages.get(this.activeFormName) as any).writtenAnswers[
      event.target.id
    ] = value;
    event.target.value = value;
  }


  setActiveFormNumber(formPageName: string): void {
    const currPageIndex = this.showedWizardPages.get(formPageName)?.formNumber;

    if (currPageIndex !== undefined) {
      if (currPageIndex === 0) {
        this.updateCookiesInFirstPage();
      }

      const userAnswers = this.collectUserAnswers();
      if (this.activeFormName === 'InsuredPage') {
        if (!this.isAlreadyInsured(userAnswers)) {
          this.activeFormIndex = this.activeFormIndex + 1;
        }
      }

      this.activeFormIndex = this.activeFormIndex + 1;
    } else {
      this.activeFormIndex = 0;
    }

    this.activeFormName = this.findPageNameByIndex(this.activeFormIndex);

    if (this.activeFormIndex === 1) {
      this.questionStart = true;
      this.questionStartChange.emit(true);
    }

    this.checkFormNumber(this.activeFormIndex);


    const userAnswers = this.collectUserAnswers();
    const sessionId = this.sessionId as string;//this.sessionService.getSessionId();
    /*userAnswers['loanSize'] = this.loanSize.replace(/[$,]/g, '');
    userAnswers['dateOfBirth'] = this.formatDateToISO(this.dateOfBirth);

    userAnswers['checkboxamMl'] = this.checkboxamMl ? 'true' : 'false';
    userAnswers['checkboxamOne'] = this.checkboxamOne ? 'true' : 'false';*/

    this.formSubmissionService
      .submitForm(userAnswers, formPageName, sessionId)
      .subscribe({
        next: () => {
          if (this.activeFormIndex === this.showedWizardPages.size) {
            const isshort = this.featureFlagService.isFFEqual('long_short_funnel_ff', 'short_funnel_version');
            /*if ((isshort && !this.googleUser) || this.isKissterraCampaign) {
              this.formSubmissionService.getRedirectLink(sessionId).subscribe({
                next: (response) => {
                  if (response) {
                    const redirectLink = response['redirectUrl'];
                    window.location.replace(redirectLink);
                  }
                },
                error: (error) => { console.log('Error on getRedirectLink', error); },
              });
            } else {*/
              this.formSubmissionService.getUserOffers(sessionId).subscribe({
                next: (offers) => {
                  if (offers) {
                    this.router.navigate(['/offers', sessionId], {
                      state: { offers: offers },
                    });
                  }
                },
                error: (error) => { console.log('Error on getUserOffers', error); },
              });
            //}
          }
        },
        error: (error: any) => { },
      });

    console.log('User answers:', userAnswers);
  }

  isAlreadyInsured(userAnswers: any): boolean {
    return userAnswers['insured'] === 'Yes';
  }

  findPageNameByIndex(index: number) {
    let pageName = '';
    this.showedWizardPages.forEach(page => {
      if (page.formNumber == index) {
        pageName = page.formPageName;
      }
    });

    return pageName
  }

  updateCookiesInFirstPage() {
    try {
      this.clientCookiesService.collectAndUpdateCookies(this.sessionId as string);
    } catch (e) {
      console.log('Error on updateCookiesInFirstPage ' + JSON.stringify(e));
    }
  }

  formatDateToISO(dateInput: string): string {
    if (dateInput) {
      // Assume dateInput is in the format "MM/DD/YYYY"
      const parts = dateInput.split('/');
      const formattedDate = `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
      return formattedDate; // "1960-06-06"
    }
    return '';
  }


  collectUserAnswers(): { [key: string]: string } {
    const answers: { [key: string]: string } = {};
    this.showedWizardPages.forEach(
      ({
        writtenAnswers,
        selectedOption,
        inputName,
        valueType,
        formPageName,
      }) => {
        if (writtenAnswers) {
          Object.entries(writtenAnswers).forEach(([key, value]) => {
            if (valueType === 'number' && typeof value === 'string') {
              value = value.replace(/\D/g, '') || '';
            }

            answers[key] = String(value || '');

          });
          if (formPageName === 'AddressPage' && this.isAddressManual) {
            Object.assign(this.address, writtenAnswers);
          }
        }

        if (selectedOption) {
          answers[inputName!] = selectedOption !== 'Please select' ? selectedOption : '';
        }
      }
    );

    return answers;
  }

  handleNavigation(formNumber: number) {
    if (formNumber === 1 || this.activeFormIndex === 0) {
      this.questionStart = false;
      this.questionStartChange.emit(false);
    }

    const userAnswers = this.collectUserAnswers();

    if (this.activeFormIndex == this.insuranceProviderPageIndex + 1) {
      if (!this.isAlreadyInsured(userAnswers)) {
        this.activeFormIndex--;
      }
    }

    this.activeFormIndex--;
    this.activeFormName = this.findPageNameByIndex(this.activeFormIndex);
  }

  handleOptionChange(
    option: string,
    formPageName: string
  ): void {
    (this.showedWizardPages.get(formPageName) as any).selectedOption = option;
    this.setActiveFormNumber(formPageName);
  }

  handleWrittenAnswers(
    formPageName: string,
    event: any,
    validation?: string
  ): void {
    if (validation === 'noNumbers') {
      event.target.value = event.target.value
        .replace(/\d/g, '')
        .replace(/[^a-zA-Z]/g, '');
    } else if (validation === 'noLetters') {
      event.target.value = event.target.value.replace(/[a-zA-Z]/g, '');
    }

    (this.showedWizardPages.get(formPageName) as any).writtenAnswers[
      event.target.id
    ] = event.target.value;
  }

  isValidDate(year: string, month: string, day: string): boolean {
    const parsedDate = new Date(`${year}-${month}-${day}`);
    return (
      parsedDate.getFullYear() === +year &&
      parsedDate.getMonth() + 1 === +month &&
      parsedDate.getDate() === +day
    );
  }

  formatDate(event: any, formPageName: string): void {
    let inputValue = event.target.value;
    if (!isNaN(Date.parse(inputValue))) {
      this.dateOfBirth = inputValue;
    }
    (this.showedWizardPages.get(formPageName) as any).writtenAnswers.dateOfBirth =
      this.dateOfBirth;
  }
  formatDateManual(event: any, formPageName: string) {
    let input = (event.target as HTMLInputElement).value;
    let eventValue = input.split('/');

    if (eventValue.length === 3 && eventValue[2].length > 4) {
      event.target.value =
        eventValue[0] +
        '/' +
        eventValue[1] +
        '/' +
        eventValue[2].substring(0, 4);
    } else {
      if (/[a-zA-Z]/.test(input)) {
        return;
      }
      if (event.inputType !== 'deleteContentBackward') {
        if (input.length > 1 && input.length < 3) {
          event.target.value = input + '/';
        } else if (input.length > 4 && input.length < 6) {
          event.target.value = input + '/';
        }
        let sanitizedInput = input.replace(/[^0-9/]/g, '');
        let date = sanitizedInput.split('/');

        if (
          (date.length === 3 &&
            date[0].length === 1 &&
            date[1].length === 1 &&
            date[2].length === 4) ||
          (date.length === 3 &&
            date[0].length === 2 &&
            date[1].length === 2 &&
            date[2].length === 4)
        ) {
          const convertedDate: any = new Date(
            `${date[2]}-${date[1]}-${date[0]}`
          );

          if (!isNaN(Date.parse(convertedDate))) {
            this.dateOfBirth = convertedDate;
          }
          (
            this.showedWizardPages.get(formPageName) as any
          ).writtenAnswers.dateOfBirth = this.dateOfBirth;
        }
      }
    }
  }
  inputFunctionForNoNumbers(event: Event): void {
    this.handleWrittenAnswers(this.activeFormName, event, 'noNumbers');
  }

  inputFunctionForNoLetters(event: Event): void {
    this.handleWrittenAnswers(this.activeFormName, event, 'noLetters');
  }

  inputFunctionWithoutValidation(event: Event): void {
    this.handleWrittenAnswers(this.activeFormName, event);
  }

  highlightWords(sentence: string, highlightedPart: string): any {
    if (!sentence || !highlightedPart) {
      return sentence;
    }

    const regex = new RegExp(`(${highlightedPart})`, 'gi');
    const highlightedSentence = sentence
      .split(regex)
      .map((part) =>
        part.toLowerCase() === highlightedPart.toLowerCase()
          ? `<span style="color: #1331d4; font-weight: 600;">${part}</span>`
          : part
      )
      .join('');

    return this.sanitizer.bypassSecurityTrustHtml(highlightedSentence);
  }

  isFormDisabled(question: WizardData): boolean {
    return Object.values(question.writtenAnswers || {}).some((value) => !value);
  }

  get wizardPagesArray() {
    return Array.from(this.showedWizardPages.values());
  }
}
